import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, LogIn } from 'lucide-react';
import { BRAND, SERVICES, NAV_LINKS } from '../mock';
import { Button } from './ui/button';

export default function Footer() {
  return (
    <footer className="bg-[#3a3a3c] text-gray-300">
      {/* CTA strip */}
      <div className="bg-[#17A2C4]">
        <div className="max-w-7xl mx-auto px-6 py-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <div>
            <h3 className="text-white text-2xl font-extrabold">Need a courier right now?</h3>
            <p className="text-white/85">Call our dispatch team and a driver will be on the way.</p>
          </div>
          <a href={BRAND.phoneHref}>
            <Button className="bg-white text-[#17A2C4] hover:bg-gray-100 font-bold text-lg px-7 py-6 gap-2">
              <Phone size={20} /> {BRAND.phone}
            </Button>
          </a>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-14 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2 md:col-span-1">
          <img src={BRAND.logo} alt="StreetFleet" className="h-12 w-auto bg-white rounded-md p-1.5 mb-4" />
          <p className="text-sm leading-relaxed text-gray-400">
            Toronto&rsquo;s trusted courier partner for Same-Day, Rush, ASAP and After-Hours deliveries across the GTA.
          </p>
        </div>

        <div>
          <h4 className="text-white font-bold mb-4 uppercase text-sm tracking-wide">Services</h4>
          <ul className="space-y-2.5 text-sm">
            {SERVICES.map((s) => (
              <li key={s.id}>
                <Link to="/services" className="hover:text-[#4FC3E0] transition-colors">{s.name} Delivery</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-bold mb-4 uppercase text-sm tracking-wide">Company</h4>
          <ul className="space-y-2.5 text-sm">
            {NAV_LINKS.map((l) => (
              <li key={l.label}>
                {l.to.includes('#') ? (
                  <a href={l.to} className="hover:text-[#4FC3E0] transition-colors">{l.label}</a>
                ) : (
                  <Link to={l.to} className="hover:text-[#4FC3E0] transition-colors">{l.label}</Link>
                )}
              </li>
            ))}
            <li>
              <a href={BRAND.loginUrl} target="_blank" rel="noopener noreferrer" className="hover:text-[#4FC3E0] transition-colors flex items-center gap-1.5">
                <LogIn size={14} /> Customer Login
              </a>
            </li>
          </ul>
        </div>

        <div className="col-span-2 md:col-span-1">
          <h4 className="text-white font-bold mb-4 uppercase text-sm tracking-wide">Contact</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2.5">
              <MapPin size={17} className="text-[#4FC3E0] mt-0.5 shrink-0" />
              <span>{BRAND.address.line1}, {BRAND.address.city}, {BRAND.address.region} {BRAND.address.postal}</span>
            </li>
            <li className="flex items-center gap-2.5">
              <Phone size={17} className="text-[#4FC3E0] shrink-0" />
              <a href={BRAND.phoneHref} className="hover:text-[#4FC3E0] transition-colors">{BRAND.phone}</a>
            </li>
            <li className="flex items-center gap-2.5">
              <Mail size={17} className="text-[#4FC3E0] shrink-0" />
              <a href={`mailto:${BRAND.email}`} className="hover:text-[#4FC3E0] transition-colors">{BRAND.email}</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-gray-500">
          <p>&copy; {new Date().getFullYear()} StreetFleet. All rights reserved.</p>
          <p>Same-Day &middot; Rush &middot; ASAP &middot; After Hours &mdash; Toronto &amp; the GTA</p>
        </div>
      </div>
    </footer>
  );
}
